import { render, staticRenderFns } from "./teams.detail.vue?vue&type=template&id=cb35c648&scoped=true&"
import script from "./teams.detail.vue?vue&type=script&lang=js&"
export * from "./teams.detail.vue?vue&type=script&lang=js&"
import style0 from "./teams.detail.vue?vue&type=style&index=0&id=cb35c648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb35c648",
  null
  
)

export default component.exports